import { Modal, Checkbox, Image, Flex, message } from "antd";
import { useState } from "react";
import { CustomTitle } from "../../components";
import { CustomParagraph } from "../../components";
import phoneAi from "../../assets/images/Aiphone.svg";
import { CustomButton } from "../../components";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import callAi from "../../assets/images/callAi.svg";
import { dontShowMessage } from "../../api's/shipment";

const CallAiAssistantModal = ({
  open,
  onCancel,
  onConfirm,
  showTranscriptModal,
  setShowTranscriptModal,
}) => {
  const { token, decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();
  const { showSpin, hideSpin } = useSpin();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setDontShowAgain(isChecked);

    const payload = {
      ai_static_message: !isChecked,
    };

    showSpin();

    dontShowMessage(token, payload)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            localStorage.setItem("@token", res?.data?.data?.data?.access);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        console.error("AI Call API Error:", error);
      })
      .finally(() => {
        hideSpin();
      });
  };
  return (
    <Modal
      className="ai-modal"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={600}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={phoneAi}
            alt="AI Icon"
            style={{ width: "20px", height: "20px" }}
          />
          <CustomTitle
            text="Call using AI Assistant"
            fontSize="20px"
            lineHeight="28px"
            fontWeight="700"
            marginBottom="0px"
          />
        </div>
      }
    >
      <Image
        src={callAi}
        alt="AI call preview"
        preview={false}
        style={{
          width: "100%",
          borderRadius: "8px",
          marginBottom: "20px",
          marginTop: "10px",
        }}
      />
      <CustomParagraph
        text={`The ZoomLogi AI Assistant will call the party in question on ${decodedToken?.company_name}'s behalf to resolve the issue. You can review the call transcript at any time in the shipment’s live chain of custody after the call is completed.`}
        fontSize="12px"
        fontWeight="400"
        lineHeight="20px"
        marginBottom="16px"
      />

      <Flex
        justify="space-between"
        align="center"
        style={{ marginTop: "32px" }}
      >
        <Checkbox
          onChange={handleCheckboxChange}
          style={{ fontWeight: 600, fontSize: "12px" }}
        >
          Don’t show this message again
        </Checkbox>

        <Flex gap="16px">
          <CustomButton
            onClick={onCancel}
            text="Cancel"
            bgColor="transparent"
            color="black"
            fontSize="14px"
            fontWeight="600"
            boxShadow="none"
            height="48px"
          />

          <CustomButton
            onClick={() => {
              onConfirm(dontShowAgain);
              // setShowTranscriptModal(true);
            }}
            text="Call with AI Assistant"
            bgColor="black"
            color="white"
            height="48px"
            fontSize="14px"
            fontWeight="600"
            boxShadow="none"
            borderRadius="8px"
          />
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CallAiAssistantModal;
